import React, { Component } from 'react';
import './../PersonRegist.css'
import Api from '../../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';




//设备信息
export default class Reward extends Component {
  constructor(props) {
    super();
    this.state = {
      sum_award_amount: "",       // 累计金额
      sum_devices: "",           // 累计查车数
    
      scan_amount:'',
      sale_amount:'',
      scan_count:''
    };

  }

  componentDidMount() {
    document.title = '奖励'
    this.getData();
  }
  render() {
    let {
     
      scan_amount,
      sale_amount,
      scan_count
    } = this.state

 
    return (
      <div className='flex-column-container' style={{ flex: 1, background: '#fff', paddingBottom: 10 }}>

        <img src={require('../../../assets/banner.png')} style={{ width: '100%', height: 200 }}></img>
        <div className='flex-row-container boxstyle' style={{ alignItems: 'center', justifyContent: "space-around", marginTop: 20, marginLeft: 15, marginRight: 15 }}>
          <div className="flex-column-container" style={{ alignItems: 'center' }} onClick={this.gotoMessage} >
            <p>¥{scan_amount}</p>
            <p style={{ marginTop: 10 }}>可领取扫描奖励</p>
          </div>
          <div style={{ height: 80, backgroundColor: '#F4F4F4', width: 2 }}></div>

          <div className="flex-column-container" style={{ alignItems: 'center' }} onClick={this.gotoReward} >
            <p>¥{sale_amount}</p>
            <p style={{ marginTop: 10 }}>可领取转化奖励</p>
          </div>
        </div>

        <div className='flex-row-container' style={{ marginTop: 40, alignItems: 'center', justifyContent: "space-between", paddingRight: 20, paddingLeft: 10 }}>
          <div className='flex-row-container' style={{ alignItems: 'center' }}>
            <img style={{ width: 50, height: 50 }} src={require('../../../assets/xiaoshou.png')}></img>
            <div className='flex-column-container' style={{ marginLeft: 10 }}>
              <p>销售成功</p>
              <p>根据查车结果,成功销售</p>
            </div>
          </div>
          <button className='right-button' style={{ width: 80, background: ( sale_amount&&sale_amount>0) ? '#FFAD26' : '#808080', borderRadius: 20, paddingTop: 5, paddingBottom: 5 }} onClick={this.getsaleApply}>领取奖励</button>
        </div>

        <div style={{ height: 2, backgroundColor: '#F4F4F4', width: '100%', marginTop: 10 }}></div>
 
        <div className='flex-row-container' style={{ marginTop: 10, alignItems: 'center', justifyContent: "space-between", paddingRight: 20, paddingLeft: 10 }}>
          <div className='flex-row-container' style={{ alignItems: 'center' }}>
            <img style={{ width: 50, height: 50 }} src={require('../../../assets/chache.png')}></img>
            <div className='flex-column-container' style={{ marginLeft: 10 }}>
              <p>累计查车</p>
              <p>检测车辆{scan_count}辆</p>
            </div>
          </div>
          <button className='right-button' style={{ width: 80, background: (scan_amount && scan_amount> 0) ? '#FFAD26' : '#808080', borderRadius: 20, paddingTop: 5, paddingBottom: 5 }} onClick={this.getjianchajl}>领取奖励</button>
        </div>

        <div style={{ height: 2, backgroundColor: '#F4F4F4', width: '100%', marginTop: 10 }}></div>
      </div>


    )
  }

  //领取销售奖励
  getsaleApply = () => {
    let { sale_amount } = this.state
    if (sale_amount) {
      let param = { type: 'sale'}
      Api.getapply({ params: param }).then(res => {
        if (res.data.code == 0) {
          let str = '本次领取' + res.data.data.amount + '元,我们的工作人员审核完毕后将会联系您'
          alert(str)
          this.getData()
        }
      })
    } else {
      alert('现在无法领取奖励')
    }

  }



  //累计查车奖励
  getjianchajl = () => {
    let { scan_amount } = this.state
    if (scan_amount) {
      let param = { type: 'scan' }
      Api.getapply({ params: param }).then(res => {
        if (res.data.code == 0) {
          let str = '本次领取' + res.data.data.amount + '元,我们的工作人员审核完毕后将会联系您'
          alert(str)
          this.getData()
        }
      })
    } else {
      alert('现在无法领取奖励')
    }
  }

  getData() {
    Api.getRewardInfomation().then(res => {
      if (res.data.code == 0) {
        let data = res.data.data
        this.setState({
          scan_amount:data.scan_amount,
          sale_amount:data.sale_amount,
          scan_count:data.scan_count

        })
      } else {

      }
    })
  }


}




// WEBPACK FOOTER //
// ./src/views/person/reward/Reward.js